<template>
  <router-link :to="`/blogs/${post.slug}`" class="blog-card">
    <div class="blog-card__media">
      <img v-if="post.featured_image_link" :src="post.featured_image_link" :alt="post.title" loading="lazy" />
      <div v-else class="blog-card__media--empty">
        <i class="pi pi-file-edit"></i>
      </div>
      <span v-if="post.is_featured" class="blog-card__featured"><i class="pi pi-star-fill"></i> مميز</span>
    </div>

    <div class="blog-card__body">
      <span v-if="post.category" class="blog-card__category">{{ post.category.title }}</span>
      <h3 class="blog-card__title">{{ post.title }}</h3>
      <p v-if="post.excerpt" class="blog-card__excerpt">{{ post.excerpt }}</p>
      <div class="blog-card__meta">
        <i class="pi pi-calendar"></i>
        <span>{{ date }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'BlogCard',
  props: {
    post: { type: Object, required: true },
  },
  computed: {
    date() {
      if (!this.post.published_at) return '';
      return new Date(this.post.published_at).toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' });
    },
  },
};
</script>

<style scoped>
.blog-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid rgba(91,95,239,.1);
  border-radius: 18px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
  height: 100%;
}
.blog-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(91,95,239,.14);
  border-color: rgba(91,95,239,.3);
  color: inherit;
}
.blog-card__media {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #f1f5f9;
}
.blog-card__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
.blog-card__media--empty {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 2.4rem;
  background: linear-gradient(135deg, #5B5FEF, #7c4dff);
}
.blog-card__featured {
  position: absolute; top: 10px; inset-inline-start: 10px;
  background: rgba(255,255,255,.92); color: #b45309;
  font-size: .72rem; font-weight: 800; padding: .25rem .6rem; border-radius: 99px;
}
.blog-card__body { padding: 1rem 1.1rem 1.1rem; flex: 1; display: flex; flex-direction: column; }
.blog-card__category {
  display: inline-block;
  background: rgba(91,95,239,.07); color: #5B5FEF;
  border-radius: 8px; padding: .2rem .55rem; font-size: .72rem; font-weight: 700;
  margin-bottom: .5rem; align-self: flex-start;
}
.blog-card__title { font-size: 1.05rem; font-weight: 800; color: #111827; margin-bottom: .4rem; line-height: 1.4; }
.blog-card__excerpt {
  font-size: .84rem; color: #6B7280; margin-bottom: .6rem; line-height: 1.6; flex: 1;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.blog-card__meta {
  display: flex; align-items: center; gap: .4rem;
  font-size: .78rem; color: #94a3b8; margin-top: auto;
}
</style>
